export const REALM_NAME = 'grin'
export const GRIN_DOMAIN = 'grin.com'

export const SUBMISSIONS_URL = 'resource/v3/my_submissions'
export const AUTOSEARCH_URL = 'rpc/autosearch'
export const LICENSE_URL = 'rpc/licenses'

export const DOCUMENT_ORIGIN = document.location.origin

export const getApiHost = () => {
  if (
    document.location.hostname === 'localhost' ||
    document.location.origin.includes('unstable')
  ) {
    return 'https://api.unstable.dev.openpublishing.com'
  } else if (document.location.origin.includes('dev.openpublishing.com')) {
    return document.location.origin.replace('grin', 'api')
  } else {
    return 'https://api.openpublishing.com'
  }
}

export const getFileUrl = (apiHost, submissionId, fileId) =>
  `${apiHost}/${SUBMISSIONS_URL}/${submissionId}/files/${fileId}`
export const getSubmissionsUrl = (apiHost) => `${apiHost}/${SUBMISSIONS_URL}`
export const getSubmissionUrl = (apiHost, submissionId) =>
  getSubmissionsUrl(apiHost) + `/${submissionId}`
export const getSubmissionFilesUrl = (apiHost, submissionId) =>
  getSubmissionUrl(apiHost, submissionId) + '/files'

export const getAutosearchUrl = (apiHost) => `${apiHost}/${AUTOSEARCH_URL}`
export const getLicensesUrl = (apiHost) => `${apiHost}/${LICENSE_URL}`
export const getEnumerationUrl = (apiHost, lang, name) =>
  `${apiHost}/enumeration/${lang}/${name}`
export const getResourceUrl = (apiHost, name) =>
  `${apiHost}/resource/v3/${name}`
